import { Chip, Stack, Tab, TabProps, Typography } from '@mui/material'

const KojinTabProps = (value: string) => ({
  id: `kojin-preview-tab-${value}`,
  'aria-controls': `kojin-preview-tabpanel-${value}`,
})

type KojinPreviewTabProps = {
  badge?: number | string
} & TabProps
export const KojinPreviewTab = ({
  label,
  value,
  badge,
  disabled,
  ...others
}: KojinPreviewTabProps) => {
  return (
    <Tab
      value={value}
      label={
        (!disabled && badge) ? (
          <Stack direction="row" spacing={0.5} alignItems="center">
            <Typography variant="button" color="inherit">
              {label}
            </Typography>
            <Chip
              variant="filled"
              color="primary"
              label={badge}
              size="small"
              sx={{
                fontSize: "10px",
                height: "unset",
                "& .MuiChip-label": {
                  paddingX: 0.5
                }
              }}
            />
          </Stack>
        ) : (
          <Typography variant="button" color="inherit">
            {label}
          </Typography>
        )
      }
      {...KojinTabProps(value)}
      {...others}
    />
  )
}
